import { deepValue } from '@corratech/pylot-utils'
import { PageViewData } from '../GTM'
import { PageViewDataKeys, isPageViewDataKey } from '../hooks/useDataLayerData'

const isAllDataDefined = (variableNames: string[], data: PageViewData) => {
    let isDataDefined = true
    variableNames.forEach((name) => {
        if (isPageViewDataKey(name) && typeof data[name] === 'undefined') {
            isDataDefined = false
        }
    })
    return isDataDefined
}

export const PAGEVIEW_EVENT = 'pageview'

export type PageViewEvent = {
    event: 'pageview'
    _clear: true
} & PageViewData

export const pushPageView = (
    eventHistory: () => string[],
    getStoredData: () => PageViewData
): PageViewEvent | undefined => {
    if (eventHistory().includes(PAGEVIEW_EVENT)) {
        return
    }
    const pageViewData = getStoredData()
    const isDataDefined = isAllDataDefined(PageViewDataKeys, pageViewData)
    const isPageNameDefined = !!deepValue(
        pageViewData,
        ['pageDetails', 'pageName'],
        false
    )
    if (!isDataDefined || !isPageNameDefined) {
        return
    }

    return {
        event: PAGEVIEW_EVENT,
        ...pageViewData,
        _clear: true
    }
}
